import { AfterViewInit, Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { SystemCodeType } from 'src/app/services/api-service/system-code/system-code-type';
import { SystemcodeApi, SystemCodeEditOption } from 'src/app/services/api-service/system-code/systemcode-api';
import { SystemCodeListGridViewComponent } from '../system-code-list-grid-view/system-code-list-grid-view.component';

@Component({
  selector: 'app-system-code-editer',
  templateUrl: './system-code-editer.component.html',
  styleUrls: ['./system-code-editer.component.css']
})
export class SystemCodeEditerComponent implements OnInit, AfterViewInit {
  configs:SystemCodeEditOption;
  currentClinicId:number;
  systemCodeType:string;
  /** 開啟匯入時使用的Type 兼開啟匯入的開關 */
  importSystemCodeType:string;
  systemTypeList:SystemCodeType[]

  @ViewChild(SystemCodeListGridViewComponent, { static: false })
  gridViewComponent: SystemCodeListGridViewComponent;

  title:string = '新增代碼';
  canEdit:boolean = true;
  onClosed:(type:string)=>void;

  constructor(private systemcodeApi:SystemcodeApi) { }

  async ngOnInit() {
  }
  setConfig(c:SystemCodeEditOption,systemCodeType:string){
    
    this.configs = c;
    this.currentClinicId = this.configs.clinicId;
    this.systemTypeList = this.configs.systemCodeTypeList
    this.systemCodeType = systemCodeType;
    this.title = '系統代碼設定：'+ this.systemTypeList.find(x=>x.Type == systemCodeType)?.Name;
    this.canEdit = this.systemTypeList.find(x=>x.Type == systemCodeType)?.CanAdd;
  }
  async ngAfterViewInit(){
    //await this.gridViewComponent.refreshList();  
  }
  onShowImport(){
    this.importSystemCodeType = this.systemCodeType;
  }

  onAddRow(){
    this.gridViewComponent.addRow()
  }
  onClose(){
    if(this.onClosed){
      this.onClosed(this.systemCodeType);
    }
  }
}
